<template>
	  <transition>
		<div class="moveBox" :style="position" v-show="ifTime">
			<div class="moveHead" @mousedown="mousedown" @mousemove="mousemove" @mouseup="mouseup" @mouseleave="mousemove">
			<!--关闭按钮-->
			</div>
			<div class="content">
				<slot></slot>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: "moveBox",
		data() {
			return {
				x: 0,
				y: 0,
				leftOffset: 0, //鼠标距离移动窗口左侧偏移量
				topOffset: 0, //鼠标距离移动窗口顶部偏移量
				isMove: false, //是否移动标识
			}
		},
		mounted() {
			this.x = (window.innerWidth - (window.innerWidth * 0.25)) / 2 + Math.floor((Math.random()  * 110))
			this.y = window.innerHeight * 0.2 + Math.floor((Math.random()  * 110))
      console.log(this.x)
      console.log(this.y)
		},
		props: {
			ifTime: false,
			title: String
		},
		computed: {
			//top与left加上px
			position() {
				return `top:${this.y}px;left:${this.x}px;`;
			}
		},
		methods: {
			//控制打开关闭
			toggleShow() {
				this.x = 100;
				this.y = 50;
				let aTime = !this.ifTime
				this.$emit('close', aTime)
			},
			mousedown(event) {
				//鼠标按下事件
				this.leftOffset = event.offsetX;
				this.topOffset = event.offsetY;
				this.isMove = true;
			},
			//鼠标移动
			mousemove(event) {
				if (!this.isMove) {
					return;
				}
				this.x = event.clientX - this.leftOffset;
				this.y = event.clientY - this.topOffset;
			},
			//鼠标抬起
			mouseup() {
				this.isMove = false;
			}
		}
	};
</script>

<style lang="less" scoped>
	.moveBox {
		// width: 500px;
		position: fixed;
		z-index: 999;
		top: 20%;
		left: 10%;

		.moveHead {
			height: 2vw;
			width: 90%;
			position: absolute;
			// background: linear-gradient(#0b1439, #1045a3);
			// border-radius: 30px 0 0 0;
			// opacity: 0.9;
			cursor: move;
			z-index: 99999;
		}

		.close {
			position: absolute;
			right: 0;
			top: 0;
			line-height: 30px;
			font-size: 24px;
			cursor: pointer;
			display: block;
			width: 30px;
			height: 30px;
			text-align: center;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/MoveBox.vue